<template>
  <guide-page v-bind:config="pageConfig" :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :shareHaderName="shareHaderName"></guide-page>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuidePage from '../component/GuidePage.vue';

export default {
  name: 'eNTRI',
  components: {
    guidePage: GuidePage,
  },
  data() {
    return {
      wxaPage: 'pages/me/guide/guide-page/guide-page',
      wxaPageParam: 'key=10',
      shareHaderName: '马来西亚eNTRI',
      pageConfig: {
        sections: [
          {
            head: {
              title: '马来西亚eNTRI',
            },
            steps: [
              {
                title: '选择“马来西亚eNTRI”商品下单',
                description: [
                  '选择需要办理的马来西亚eNTRI（免签登记）商品，点击「立即办理」；',
                  '马来西亚eNTRI不支持线下邮寄的方式提交资料，输入订单基本信息，与原下单流程一致。',
                ],
                sub: [
                  {
                    images: [{ name: 'entri-1' }],
                  },
                ],
              },
              {
                title: '上传电子资料',
                description: [
                  '马来西亚eNTRI（免签登记）商品只需上传照片和护照首页，系统会自动处理照片并且识别签证信息，无需其他资料。',
                ],
                sub: [
                  {
                    images: [
                      {
                        name: 'entri-2',
                      },
                    ],
                  },
                ],
              },
              {
                title: '支付订单',
                description: [
                  '按照现有支付流程，支付平台服务费。',
                  '注：此步骤支付成功后还需支付160元/本的使馆签证费',
                ],
                sub: [
                  {
                    images: [{ name: 'entri-3' }],
                  },
                ],
              },
              {
                title: '确认信息',
                description: [
                  '支付完成弹出「支付成功」的弹窗，点击「提交至使馆」的按钮。选择申请人，打开「补充并确认」资料页面，点击「确认信息无误」，并「提交至使馆」。',
                ],
                sub: [
                  {
                    images: [
                      { name: 'entri-4' },
                      { name: 'entri-5' },
                    ],
                  },
                ],
              },
              {
                title: '系统自动提交资料至使馆',
                description: [
                  '点击「提交至使馆」按钮后，系统会自动进行注册、激活、登录账号等流程，此时需耐心等待，如遇失败点击「重试」即可。',
                ],
                sub: [
                  {
                    images: [
                      { name: 'entri-6' },
                    ],
                  },
                ],
              },
              {
                title: '支付使馆费用',
                description: [
                  '资料提交成功后，点击「立即支付」的按钮，浏览器会打开使馆费用支付页面，使用手机支付宝扫一扫或PC端登录付款，付款成功等待使馆出签。',
                ],
                sub: [
                  {
                    images: [
                      { name: 'entri-7' },
                    ],
                  },
                ],
              },
              {
                title: '出签成功',
                description: [
                  '出签成功后，订单详情页面可下载电子签。',
                ],
                sub: [
                  {
                    images: [
                      { name: 'entri-8' },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '马来西亚eNTRI',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/guide/sub/eNTRI.vue